/*
 * @Description:
 * @Author: 樊文静
 * @LastEditors: 樊文静
 * @Date: 2021-10-11 13:53:31
 * @LastEditTime: 2021-10-12 18:14:28
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\permissionSettings.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const { host = "", E6_MS_TMS_PERSONALIZE_WEB = "" } = e6ModuleBaseDataApi;

//获取用户管理表格数据
export function getColumnsInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_PERSONALIZE_WEB}/tms/field/getColumnsInfo`,
    method: "post",
    data
  });
}
// 角色字段权限设置 - 保存
export function saveRoleFieldSet(data) {
  return http({
    url: `${host}${E6_MS_TMS_PERSONALIZE_WEB}/roleFieldSet/saveRoleFieldSet`,
    method: "post",
    data
  });
}
// 角色字段权限获取选中的项
export function queryRoleFieldSet(data) {
  return http({
    url: `${host}${E6_MS_TMS_PERSONALIZE_WEB}/roleFieldSet/queryRoleFieldSet`,
    method: "post",
    data
  });
}
